import { render, staticRenderFns } from "./smallStats.vue?vue&type=template&id=106b0fd3&scoped=true"
import script from "./smallStats.vue?vue&type=script&lang=js"
export * from "./smallStats.vue?vue&type=script&lang=js"
import style0 from "./smallStats.vue?vue&type=style&index=0&id=106b0fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b0fd3",
  null
  
)

export default component.exports